module.exports = __webpack_public_path__ + "media/img0.08304a49.mp4";